import { getSignedUrl, uploadToS3 } from 'api/s3';

type UploadStrategy = 's3' | 'remote' | 'memory';
type UploadFn = (file: File) => Promise<string>;

const getUploadStrategy = (strategy: UploadStrategy, uploadFn?: UploadFn): UploadFn => {
    return async (file: File) => {
        switch (strategy) {
            case 'remote':
                if (uploadFn) {
                    return uploadFn(file);
                }
                return '';
            case 's3': {
                const { url } = await getSignedUrl();
                await uploadToS3(url, file);
                return url;
            }
            case 'memory':
                return Promise.resolve('');
        }
    };
};

export { getUploadStrategy };
export type { UploadStrategy };
